import React from 'react';
import { Modal, DatePicker, Form, Select, Icon, Button, Table, Empty } from 'antd';
import moment from 'moment';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }



    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Detalle de Resumen Diario"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Aceptar"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel}
                style={{ top: 30 }}
                width="1100px"
            >
                <Form>


                    <div className="row">
                        <div className="col-md-3 form-group">

                        
                        </div>

                        <div className="col-md-6 form-group">
                        
                        </div>

                        <div className="col-md-3 form-group">
                      
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto', marginTop: 10 }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                  
                                    {
                                        title: 'Cliente',
                                        dataIndex: 'razonSocialCliente',
                                        key: 'razonSocialCliente'
                                    },
                                    {
                                        title: 'Tipo de Comprobante',
                                        dataIndex: 'tipoComprobante',
                                        key: 'tipoComprobante'
                                    },
                                    {
                                        title: 'Serie / Documento',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        render: (data, row) => (
                                            <span>{row.serie}-{row.documento}</span>
                                        )
                                    },
                                    {
                                        title: 'Total',
                                        dataIndex: 'total',
                                        key: 'total',
                                        align: 'right',
                                        render: (data) => (
                                            <span>{data.toFixed(2)}</span>
                                        )
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)